export enum RouterName {
  /** 라우터명 */
  Auth = '인증',
  Login = '로그인',
  LoginTarget = '로그인 대상',
  FCMAssistant = 'FCM 어시스턴트',
  MMSAssistant = 'MMS 어시스턴트',
  NoPage = '404 페이지',
}
